import React, { useEffect } from 'react';
import { ThemeProvider, ThemeConfig } from '@privemind/components';
import { portfolioStore } from './stores/portfolio-store';
import { AuthManager } from './components/auth/auth-manager/auth-manager';
import { AppContent } from './app-content';
import './app.scss';

const darkThemeConfig: ThemeConfig = {
  colors: {
    baseColors: {
      primary: '#4f46e5',
      secondary: '#6b7280',
      danger: '#dc2626',
      success: '#10b981',
      warning: '#f59e0b',
      info: '#3b82f6',
    },
    surfaceColors: {
      background: '#111827',
      surface: '#1f2937',
    },
  },
};

export const App: React.FC = () => {
  useEffect(() => {
    // Initial price fetch on app load
    portfolioStore.updatePricesForAllAssets();

    // Set up periodic price refresh every 20 minutes
    const priceRefreshInterval = setInterval(() => {
      portfolioStore.updatePricesForAllAssets();
    }, 20 * 60 * 1000); // 20 minutes in milliseconds

    // Cleanup interval on component unmount
    return () => {
      clearInterval(priceRefreshInterval);
    };
  }, []);

  return (
    <ThemeProvider theme={darkThemeConfig}>
      <AuthManager>
          <AppContent />
      </AuthManager>
    </ThemeProvider>
  );
};